import { render, staticRenderFns } from "./CreditInTab.vue?vue&type=template&id=5bed8490"
import script from "./CreditInTab.vue?vue&type=script&lang=js"
export * from "./CreditInTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports